var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7C13.75 7.14918 13.6907 7.29226 13.5852 7.39775C13.4798 7.50324 13.3367 7.5625 13.1875 7.5625H7.5625V13.1875C7.5625 13.3367 7.50324 13.4798 7.39775 13.5852C7.29226 13.6907 7.14918 13.75 7 13.75C6.85082 13.75 6.70774 13.6907 6.60225 13.5852C6.49676 13.4798 6.4375 13.3367 6.4375 13.1875V7.5625H0.8125C0.663316 7.5625 0.520242 7.50324 0.414753 7.39775C0.309263 7.29226 0.25 7.14918 0.25 7C0.25 6.85082 0.309263 6.70774 0.414753 6.60225C0.520242 6.49676 0.663316 6.4375 0.8125 6.4375H6.4375V0.8125C6.4375 0.663316 6.49676 0.520242 6.60225 0.414753C6.70774 0.309263 6.85082 0.25 7 0.25C7.14918 0.25 7.29226 0.309263 7.39775 0.414753C7.50324 0.520242 7.5625 0.663316 7.5625 0.8125V6.4375H13.1875C13.3367 6.4375 13.4798 6.49676 13.5852 6.60225C13.6907 6.70774 13.75 6.85082 13.75 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.988a0e0a3f3f8b1c636ee59f1f339731.svg";
export { ForwardRef as ReactComponent };